<div class="shop-list-item" [class.active]="shop().name === activeShopName()" (click)="onClickShop(shop().name || '')">
  <div class="address text-b4-m-500 text-lg-b2-s-500">
    {{ shop().addressFormatted }}
  </div>

  @if (shop().displayName; as displayName) {
    <div class="display-name text-b3-s-300 text-lg-b2-s-300">
      {{ displayName }}
    </div>
  }

  @if (shop().distanceKm; as distanceKm) {
    <div class="distance text-b3-s-500">{{ distanceKm | sdDistanceFromYou }} от вас</div>
  }

  <div class="working-time">
    <sd-shop-working-time [shop]="shop()"></sd-shop-working-time>
  </div>

  @if (showAvailability()) {
    @let pickupDate = shop().pickupDate;
    @let deliveryDate = pickupDate ? (pickupDate | sdDeliverIn: 'dd.MM' | async) : null;

    @if (shop().available) {
      <div class="availability text-b3-s-500 color-green">
        в наличии {{ shop().available | formattedNumber: '1.0-2' }} {{ shop().unit?.name || '' }}
      </div>
    } @else if (pickupDate) {
      <div class="availability text-b3-s-500 color-orange">
        привезем {{ deliveryDate }}
        @if (deliveryDate !== 'сегодня') {
          при заказе сегодня
        }
      </div>
    }
  }
</div>
